import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useDynamicTranslation } from "@/hooks/useDynamicTranslation";

export function AreYouSureDialog({ title, description, onConfirm, onCancel, onClose, open }: any) {
  const { t } = useDynamicTranslation("shared");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={onClose}
      aria-labelledby="are-you-sure-dialog-title"
    >
      <DialogTitle id="are-you-sure-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button autoFocus color="error" onClick={onCancel ?? onClose}>
          {t("cancel")}
        </Button>
        <Button onClick={onConfirm} autoFocus>
          {t("confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AreYouSureDialog.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
